import useTranslation from "next-translate/useTranslation";
import { Flex, Box } from "rebass/styled-components";
import Button from "../common/Button";
import Icon from "../common/Icon";
import { useStepByStepState, useStepByStepDispatch } from "./StepByStepContext";

interface Props {
  nextLabel?: string;
  prevLabel?: string;
  blockNext?: boolean;
  blockPrev?: boolean;
}

const BaseActions = ({ nextLabel, prevLabel, blockNext, blockPrev }: Props) => {
  const { t } = useTranslation("common");
  const { active, flow, isNextBtnVisible } = useStepByStepState();
  const dispatch = useStepByStepDispatch();

  const visible = flow[active];

  const next = () => {
    if (visible && visible.do) {
      visible.do();
    } else {
      if (active + 1 < flow.length) {
        dispatch({
          type: "changeActive",
          payload: { active: active + 1 }
        });
      }
    }
  };

  const prev = () => {
    if (visible && visible.undo) {
      visible.undo();
    } else {
      dispatch({
        type: "changeActive",
        payload: { active: active - 1 }
      });
    }
    dispatch({
      type: "changeNextBtnVisibility",
      payload: { isNextBtnVisible: true }
    });
  };

  return (
    <Flex justifyContent="space-between" flexDirection="row-reverse">
      <Box>
        {!blockNext && (
          <Button
            variant="secondary"
            onClick={() => next()}
            disabled={!isNextBtnVisible}
            // sx={{ opacity: isNextBtnVisible ? 0.5 : 1 }}
          >
            {nextLabel || (flow.length - active - 1 ? t("next") : t("finish"))}
          </Button>
        )}
      </Box>
      {!!active && !blockPrev && (
        <Flex alignItems="center">
          <Icon name="arrow-left" color="springGreen" />

          <Button variant="link" color="springGreen" onClick={() => prev()}>
            {prevLabel || t("back")}
          </Button>
        </Flex>
      )}
    </Flex>
  );
};

BaseActions.defaultProps = {
  nextLabel: "",
  prevLabel: "",
  blockNext: false
};

export default BaseActions;
